import { css } from "@emotion/core"
import { theme } from "../constants"

export const errorTextStyles = css`
  font-size: ${theme.fontSizes[2]};
  color: ${theme.colors.danger};
`

export const phoneInputStyles = (hasError) => css`
  .intl-tel-input {
    display: flex;
    color: ${theme.colors.text};
    font-family: ${theme.fonts.primary};

    input[type="tel"] {
      max-height: 44px;
      overflow: hidden;
      width: 100%;
      min-width: 16.82em;
      padding: 12px 8px;
      background-color: ${theme.colors.purple[800]};
      color: ${theme.colors.text};
      font-family: ${theme.fonts.primary};
      font-size: ${theme.fontSizes[4]};
      border-radius: ${theme.radii[11]};
      border: 1px solid
        ${hasError ? theme.colors.danger : theme.colors.purple[800]};
      box-shadow: ${theme.shadows.regular};

      &:disabled {
        opacity: 0.3;
        background: ${theme.colors.purple[900]};
        color: ${theme.colors.text};
        border: none;
        box-shadow: none;
        &:hover {
          border: none;
        }
        .selected-flag {
          opacity: 0.3;
          cursor: disabled;
        }
      }

      &:hover,
      &:focus,
      &:active {
        border: 1px solid
          ${hasError ? theme.colors.danger : theme.colors.purple[800]};
      }

      &::placeholder {
        color: ${theme.colors.grey[400]};
      }
      &:read-only {
        opacity: 0.3;
        background: ${theme.colors.purple[800]};
      }
    }
  }

  .react-tel-input {
    margin-top: 10px !important;
    margin-left: 10px !important;
  }

  .flag-dropdown {
    background-color: ${theme.colors.purple[800]} !important;
  }

  .selected-flag {
    display: flex !important;
    align-items: center;
    width: 70px;
  }

  .flag-container {
    left: 0;
  }

  .intl-tel-input.allow-dropdown.separate-dial-code .selected-dial-code {
    vertical-align: middle;
    padding-left: 12px;
    color: ${theme.colors.text};
    font-weight: bold;
  }

  .intl-tel-input .flag-container .arrow {
    display: none !important;
  }

  .intl-tel-input .country-list .flag-box,
  .intl-tel-input .country-list .country-name,
  .intl-tel-input .country-list .dial-code {
    vertical-align: inherit;
  }
  .intl-tel-input .country-list {
    background-color: ${theme.colors.purple[800]} !important;
    white-space: inherit !important;
    color: ${theme.colors.text};
    font-weight: bold;
    border-radius: ${theme.radii[3]};
    border: none;
    margin-top: 5px;
  }
  .intl-tel-input .country-list .flag-box,
  .intl-tel-input .country-list .country-name,
  .intl-tel-input .country-list .dial-code {
    vertical-align: baseline !important;
  }
  .intl-tel-input .country-list .flag-box,
  .intl-tel-input .country-list .country-name {
    margin-right: 14px !important;
  }

  &:focus {
    outline: 0;
  }
`

export const phoneInputContainerStyles = (hasError) => css`
  position: relative;
  font-family: ${theme.fonts.primary};
  ${theme.presets.flexColumn};
  ${theme.presets.flexXYCentered};
  .error-text {
    margin-top: 8px;
    margin-left: 4px;
    text-align: left;
    width: 95%;
    ${errorTextStyles}
  }
  ${phoneInputStyles(hasError)}
`

export const phoneNoBorderContainerStyles = css`
  #otp-input {
    color: ${theme.colors.text};
    font-family: ${theme.fonts.primary};
    font-style: normal;
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes[6]};
    line-height: ${theme.lineHeights[1]};
    background: none;
    border: none;
    border-radius: 0;
    max-height: 44px;
    overflow: hidden;
    width: 100%;
  }
  .country-list {
    display: none !important;
  }
  .flag-container {
    .selected-flag {
      background: none !important;
      .arrow {
        display: none;
      }
      .selected-dial-code {
        display: none;
      }
      .iti-flag {
        margin: 8px auto;
      }
    }
  }
  .intl-tel-input input[type="tel"]:disabled {
    opacity: 1 !important;
    box-shadow: none !important;
  }
`
export const containerBg = css`
	height: 50vh;
	width: 30vw;
	background: ${theme.gradients.violetWhitePink}
  padding: 1em;
  `
export const loading = css`
  position: absolute;
  right: 5px;
  width: 40px;
`
export const editIcon = css`
  position: absolute;
  color: ${theme.colors.text};
  font-size: 20px;
  right: 10px;
`
export const tickIcon = css`
  position: absolute;
  right: 8px;
  background: transparent;
  mix-blend-mode: normal;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  background: ${theme.colors.purple[400]};
  border-radius: 45.5px;
  padding: 3px 7px;
  cursor: pointer;
`
export const tickImg = css`
  width: 13px;
`
